import { observer } from "mobx-react-lite";
import ConsoleIframe from "../../../components/Home/Iframe/ConsoleIframe";

const AdsGenerationIframe = () => {
	return <ConsoleIframe translationPrefix="adsGeneration.iframe" />;
};

export default observer(AdsGenerationIframe);
